import React from 'react';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  EditSbatGroupLessonForm,
  LECTURE_LESSON_TYPES,
  LESSON_INPUT_OPTIONS,
  LESSON_TYPES,
  PlaylistField,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import SbatGroupLessonChip from '../SbatGroupLessonChip';
import styles from './LectureRequirements.module.scss';

function LectureRequirements({ sbatGroup, classTag }) {
  const academyTopic = sbatGroup?.academy_topic;
  const { value: classTagValue } = classTag || {};
  const { lessons, playlist_owner: playlistOwner } = academyTopic || {};

  return (
    <Field
      label="Lecture Requirements"
      labelClassName="m-b-xs"
    >
      <div className="m-b-s">
        {LECTURE_LESSON_TYPES.map((lessonType) => (
          <SbatGroupLessonChip
            sbatGroup={sbatGroup}
            lessonType={lessonType}
            title={LESSON_INPUT_OPTIONS[lessonType].label}
            key={lessonType}
          />
        ))}
      </div>
      {lessons.map((lesson) => {
        const { lesson_type: lessonType } = lesson;
        const label = LESSON_INPUT_OPTIONS[lessonType]?.label;
        const isLiveLecture = lessonType === LESSON_TYPES.liveLecture;

        return (
          label && (
            <EditableSection
              canEdit
              title={label}
              className="m-b-s"
              key={lesson.id}
            >
              {(editableProps) => (
                <>
                  <div className="row">
                    <EditSbatGroupLessonForm
                      {...editableProps}
                      sbatGroup={sbatGroup}
                      value={lesson}
                      label={label}
                      classTagValue={classTagValue}
                    />
                    {lesson.lesson_type === LESSON_TYPES.liveLecture && (
                      <Tappable
                        className={classNames('link m-b-s', styles.meetingLink)}
                        href={`/meetings/permalink/${sbatGroup.meeting.id}`}
                        noHighlight
                        target="_blank"
                      >
                        Meeting link
                      </Tappable>
                    )}
                  </div>
                  {isLiveLecture && (
                    <PlaylistField playlistOwner={playlistOwner} />
                  )}
                </>
              )}
            </EditableSection>
          )
        );
      })}
    </Field>
  );
}

export default LectureRequirements;
